import { PortableTextTypeComponent } from "@portabletext/react";
import FuturesProps from "./FuturesProps";
import OddsUnavailable from "./OddsUnavailable";
import TeamProps from "./TeamProps";
import { DynamicOdds } from "./tempTypes";

const Odds: PortableTextTypeComponent<DynamicOdds> = (props) => {
  const { value } = props;

  if (value.odds.props?.length === 0) {
    return <OddsUnavailable />;
  }

  if (value.odds.type === "CORE MARKET") {
    return <TeamProps {...value} />;
  }

  return <FuturesProps {...value} />;
};

export default Odds;
